import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../../../theme';
// Electric Amber on a low-opacity tint. The pill is designed to sit on the
// dark Loci hero surfaces (teal → navy gradient with bottom-darken); the
// amber text reads ~9:1 against the composited dark background and the pill
// border gives it shape. Consumers placing this on a light surface must
// verify contrast themselves.
const AMBER_COLOR = '#FFB020';
const AMBER_BG = 'rgba(255, 176, 32, 0.14)';
const AMBER_BORDER = 'rgba(255, 176, 32, 0.32)';
const SUBTLE_BG = 'rgba(255, 255, 255, 0.04)';
const SUBTLE_BORDER = 'rgba(255, 255, 255, 0.08)';
const BASE_CLASSES = 'inline-flex items-center rounded-full font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1';
export const AmberPill = forwardRef(({ subtle = false, children, className, style, ...rest }, ref) => {
    const theme = useTheme();
    const amberStyles = {
        fontFamily: theme.typography.fontFamilyMono,
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        padding: '3px 10px',
        borderWidth: '0.5px',
        borderStyle: 'solid',
        backgroundColor: subtle ? SUBTLE_BG : AMBER_BG,
        color: subtle ? theme.colors.textMuted : AMBER_COLOR,
        borderColor: subtle ? SUBTLE_BORDER : AMBER_BORDER,
        '--tw-ring-color': theme.colors.ring,
        ...style,
    };
    const classes = [BASE_CLASSES, className].filter(Boolean).join(' ');
    return (_jsx("span", { ref: ref, className: classes, style: amberStyles, ...rest, children: children }));
});
AmberPill.displayName = 'AmberPill';
